import React from 'react';
export function Footer() {
  return <footer className="w-full" data-id="element-196">
      <img src="https://cdn.magicpatterns.com/uploads/35kkxEFKJUdPBkbkUdFBhX/Screenshot_2026-02-02_at_2.39.42_PM.png" alt="All Star Healthcare Solutions Footer" className="w-full h-auto" data-id="element-197" />
    </footer>;
}